/* eslint-disable */
import "../../components/component-questionnaire/B4FDate/react-datepicker.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import Fab from "@material-ui/core/Fab";
import SaveIcon from "@material-ui/icons/Save";
import EditIcon from "@material-ui/icons/Edit";

import {
  getPart,
  updateFundPart,
} from "../../utils/store/actions/funds.actions";
import { Input, Button } from "@material-ui/core";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 800,
    },
  },
};

const styles = (theme: Theme) =>
  createStyles({
    input: {
      "&:focus": {
        outline: "none !important",
        border: "1px solid red",
      },
    },
    backPageComponent: {
      display: "flex",
      alignItems: "center",
      margin: "1%",
    },
    backButton: {
      borderRadius: "5px",
      backgroundColor: "white",
      margin: "1%",
    },
    backInput: {
      marginLeft: "3%",
      display: "flex",
      alignItems: "center",
      fontSize: "20px",
      color: "black",
    },
    savePart: {
      color: "white",
      textTransform: "none",
      backgroundColor: "#ae0064",
      width: "-webkit-fill-available",
      margin: "0.5%",
      position: "sticky",
      bottom: 0,
    },
  });
class PartBackInput extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      part: {},
    };
  }
  queryString = window.location.search;
  urlParams = new URLSearchParams(this.queryString);
  fundPersonId = this.urlParams.get("id");

  async componentDidMount() {
    this.setState({ part: this.props.Funds.part });
  }

  handleBackPage = () => {
    window.location.href = `/admin/funds/details?id=${
      this.fundPersonId
    }&tab=${Cookies.get("tab")}`;
  };

  handleSave = (e: any) => {
    this.props.updateFundPart(this.state.part, this.fundPersonId).then(() => {
      this.props.getPart(this.fundPersonId, this.state.part.id);
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.backPageComponent}>
        <Fab
          onClick={(e: any) => this.handleBackPage()}
          className={classes.backButton}
          size="small"
        >
          <ArrowBackIosIcon
            style={{ fontSize: "12px" }}
            className={classes.extendedIcon}
          />
        </Fab>
        <div className={classes.backInput}>
          {this.state.editFundName ? (
            <Input
              id="person.name"
              value={this.state?.part?.name}
              onChange={(e) =>
                this.setState({
                  part: {
                    ...this.state?.part,
                    name: e.target.value,
                  },
                })
              }
            />
          ) : (
            this.state?.part?.name
          )}
          {this.state.editFundName ? (
            <Button
              onClick={(e) => {
                this.handleSave(e),
                  this.setState({
                    editFundName: false,
                  });
              }}
            >
              <SaveIcon />
            </Button>
          ) : (
            <Button
              onClick={() =>
                this.setState({
                  editFundName: true,
                })
              }
            >
              <EditIcon />
            </Button>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getPart,
  updateFundPart,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(PartBackInput)));
